module.exports = __webpack_public_path__ + "static/media/football.fc328718.csv";